import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
  textRight: {
    textAlign: 'right',
  },
  tableContainer: {
    marginTop: theme.spacing(1.5),
    boxShadow: 'none',
    border: 'none',
    '& .MuiTable-root': {
      borderCollapse: 'separate',
      borderSpacing: 0,
    },
  },
  tableBody: {},
  table: {
    '& .MuiTableCell-root': {
      borderRight: 'none',
      borderLeft: 'none',
      borderTop: 'none',
    },
  },
  headerRow: {
    backgroundColor: 'transparent',
    '& .MuiTableCell-root': {
      borderBottom: `1px solid ${theme.palette.dividerV2.main}`,
    },
  },
  headerCell: {
    padding: theme.spacing(0, 0, 2, 0),
    fontSize: '12px',
    fontWeight: 400,
    color: theme.palette.labraText.description,
    lineHeight: '16px',
    backgroundColor: 'transparent',
    fontFamily: 'Inter, sans-serif',
  },
  dataRow: {
    '& .MuiTableCell-root': {
      borderBottom: `1px solid ${theme.palette.dividerV2.main}`,
    },
    '&:last-child .MuiTableCell-root': {
      borderBottom: 'none',
      paddingBottom: 0,
    },
    '&:last-child td': {},
  },
  dataCell: {
    padding: theme.spacing(2, 0),
    fontSize: '16px',
    fontWeight: 400,
    color: theme.palette.labraText.tertiary,
    lineHeight: '24px',
  },
  currency: {
    fontSize: '12px',
    lineHeight: '16px',
    textAlign: 'end',
    color: theme.palette.labraText.description,
  },
  numberValue: {
    fontSize: '14px',
    lineHeight: '20px',
    color: theme.palette.labraText.tertiary,
    textAlign: 'end',
    fontWeight: 400,
  },
}))
